Use this section when you need to drive API sequence authoring from the
Canary CLI. The conceptual model lives in `api-sequences`; this section is
only command orientation. Prefer each command's `--help` output for the
current flag list.

COMMON FLOW

  1. Inspect the API catalog for candidate endpoints.

       canary api-catalog sources list
       canary api-catalog endpoints list --search <keyword>
       canary api-catalog endpoints get <apiRequestId>

  2. Compose a sequence JSON file locally. Reference endpoints by
     apiRequestId and chain steps with {{stepId.response.path}}.

  3. Create an API-only workflow from the sequence file.

       canary workflow create --api-only --name "smoke: create project" \
         --sequence-from-file seq.json

     The command returns the workflow, sequence, and node IDs.

  4. Execute immediately to surface template warnings and API failures.

       canary workflow api-sequence execute <workflowId>

  5. Inspect the run and iterate on the sequence file.

       canary workflow runs list <workflowId> --side api
       canary workflow runs get <workflowId> <runId>
       canary workflow api-sequence update <workflowId> --from-file seq.json

REFERENCE

  - Command help: `canary workflow api-sequence --help`
  - Workflow creation help: `canary workflow create --help`
  - API catalog help: `canary api-catalog --help`
